import React, { useState } from "react";
import CtiScreenImage from "../../assets/cti-screen-pop.png";
import LogoIcon from "../../assets/logo-icon.png";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import OTPVerification from "../../components/Auth/OTPVerification";
import CustomButton from "../../components/Button/CustomButton";
import SocialLogin from "../../components/Auth/Login/SocialLogin";
import { Link, useNavigate } from "react-router-dom";
import CreateCompany from "../../components/Company/CreateCompany";
import apiClient from "../../services/apiClient";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../../features/user/UserSlice";
import toast from "react-hot-toast";

const SignupScreen = () => {
  const [currentScreen, setCurrentScreen] = useState("SIGN_UP");
  const [companyOwner, setCompanyOwner] = useState();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Function to switch to the OTP screen
  const handleSignupSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        email_id: email,
      };
      await apiClient.post("/authUser", payload);

      setCurrentScreen("OTP_SCREEN");
      toast.success("OTP Sent");
    } catch (err) {
      console.log("error!", err);
    } finally {
      setLoading(false);
    }
  };

  // Function to close the popup after OTP submission
  const handleOTPSubmit = (response) => {
    // console.log(response);

    if (!response?.user?.company_id) {
      setCurrentScreen("CREATE_COMPANY");
      setCompanyOwner(response?.user?.id);
    } else {
      dispatch(
        setUserDetails({
          id: response?.user?.id,
          company_id: response?.user?.company_id,
          name: response?.user?.name,
          email: response?.user?.email_id,
          phone_number: response?.user?.phone_number,
          image: response?.user?.image,
          role: response?.user?.user_type,
          company_domain: response?.user?.company_details?.domain,
        })
      );
      if (response?.user?.name.length) {
        toast.success("Welcome!");
        navigate("/");
      } else {
        toast("please complete your profile!");
        navigate("/profile-page");
      }
    }
  };

  return (
    <section className="loginForm text-center">
      <div className="container-fluid min-vh-100 d-flex align-items-center p-0">
        <div className="row m-0 w-100 min-vh-100">
          <div className="col-md-5 d-flex min-vh-100 flex-column justify-content-center align-items-center bg-light p-4">
            <div className="mb-4">
              <img src={LogoIcon} alt="Logo" style={{ width: "100px" }} className="img-fluid" />
            </div>

            {currentScreen === "SIGN_UP" && (
              <>
                <div className="w-75">
                  <h3 className="title">Sign Up for Success</h3>

                  <SocialLogin
                    handleSocialLoginResponse={(response) => handleOTPSubmit(response)}
                  />
                  <div className="d-flex justify-content-center my-2">
                    <hr className="w-25 mx-2" />
                    <p>or continue with email</p>
                    <hr className="w-25 mx-2" />
                  </div>

                  <form onSubmit={handleSignupSubmit} className="mt-4">
                    <div className="inputData withIcon my-3">
                      <span className="icon">
                        <MailOutlineIcon />
                      </span>
                      <input
                        type="email"
                        name="email"
                        className="form-control my-2"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                      <label htmlFor="email">Email</label>
                    </div>
                    <CustomButton
                      type="submit"
                      className="my-2"
                      width={"100%"}
                      size="large"
                      loading={loading}
                    >
                      Sign Up
                    </CustomButton>
                  </form>
                </div>

                <p className="resend">
                  Already have an account?{" "}
                  <Link className="" to={"/sign-in"}>
                    Sign In
                  </Link>
                </p>

                <p className="footerAuth">
                  <small>
                    <a href="/privacy-policy">Privacy Policy</a> | <a href="/contact">Contact Us</a>
                  </small>
                </p>
              </>
            )}

            {currentScreen === "OTP_SCREEN" && (
              <OTPVerification
                handleOTPSubmit={handleOTPSubmit}
                resendOTP={handleSignupSubmit}
                email={email}
                onBack={() => setCurrentScreen("SIGN_UP")}
              />
            )}

            {currentScreen === "CREATE_COMPANY" && (
              <>
                <CreateCompany user_id={companyOwner} />
              </>
            )}
          </div>

          <div className="col-md-7 d-none d-md-flex align-items-center justify-content-center">
            <div className="fromImage">
              <img src={CtiScreenImage} alt="Right Section" className="img-fluid" />
              <h3 className="mb-2">Transform Every Call into a Success</h3>
              <p>
                Maximize Efficiency and Customer Satisfaction with{" "}
                <br className="d-non d-xl-block" />
                Our Intuitive Calling CRM Solution.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignupScreen;
